<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>信息查询</el-breadcrumb-item>
        <el-breadcrumb-item>基础内容</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">基础内容</h2>
        </div>
        <div class="right">
        </div>
      </div>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">内容列表</h3>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="参数名称"
            align="center"
            width="180"
          >
            <template slot-scope="scope" v-if="paramResult.length">
              <span>{{paramResult.find(v=>{ return v.id==scope.row.param_id }).name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="college_name"
            label="年份"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <span>{{(scope.row.year?scope.row.year:'/')}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="college_name"
            label="院校"
            align="center"
            width="160"
          >
          </el-table-column>
          <el-table-column
            label="专业"
            align="center"
            width="160"
          >
            <template slot-scope="scope">
              <span>{{(scope.row.major_code?`(${scope.row.major_code})${scope.row.major_name}`:'/')}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="content_text"
            label="文字"
            align="center"
            width="300"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="content_img"
            label="图片"
            align="center"
            min-width="320"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.content_img">
                <el-image
                  v-for="(item,index) in scope.row.content_img.split(',')"
                  :key="index"
                  style="width: 60px; height: 60px;margin:0px 5px"
                  :src="item"
                ></el-image>
              </div>
              <div v-else>
                /
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="content_file"
            label="文件"
            align="center"
            width="200"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="openfile(scope.row)"
                :disabled="scope.row.content_file==''"
              >查看文件</el-button>
            </template>

          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            align="center"
            width="300"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{(scope.row.remark?scope.row.remark:'/')}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            align="center"
            width="180"
          >
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY-MM-DD HH:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="修改时间"
            align="center"
            width="180"
          >
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.update_time).format("YYYY-MM-DD HH:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="openCollegeBasicDetailEditDialog(scope.row)"
                v-if="scope.row.is_content_detail"
              >详情</el-link>
              <el-link
                type="danger"
                :underline="false"
                @click="handleToRemove(scope.row)"
              >删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <CollegeBasicDetailEdit
      :visible="CollegeBasicDetailEditDialog"
      @close="CollegeBasicDetailEditDialog=false"
      :content="CollegeBasicDetailEditContent"
      @submit="fetchList()"
    />
  </div>
</template>

<script>


import { contentlist, contentDelete, paramlist } from "@/api/query";
import CollegeBasicDetailEdit from '@/components/dialog/query/CollegeBasicDetailEdit.vue'

export default {
  components: {
    CollegeBasicDetailEdit
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
      CollegeBasicDetailEditDialog: false,
      CollegeBasicDetailEditContent: {},
      paramResult: [],
    };
  },
  created() {
    this.fetchList()
    this.fetchParamList()
  },
  methods: {
    fetchList() {
      contentlist(this.query).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 参数列表
    fetchParamList() {
      paramlist({ isPaging: 0 }).then((res) => {
        let arr = []
        res.list.forEach(item => {
          arr = arr.concat([...item.children])
        })
        this.paramResult = arr
      });
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchList();
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
    handleToRemove(row) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        contentDelete({ id: row.id }).then(res => {
          this.$message.success(`删除成功`)
          this.fetchList()
        })
      }).catch(() => { })
    },
    openCollegeBasicDetailEditDialog(row) {
      this.CollegeBasicDetailEditContent = JSON.parse(JSON.stringify(row))
      this.CollegeBasicDetailEditDialog = true
    },
    formateCategory(id) {
      const obj = {
        1: "热门问题",
        2: "客户关系问题",
        3: "业绩统计问题",
      };
      return obj[id] || "无"
    },
    openfile(row) {
      let file = JSON.parse(row.content_file)[0].url
      window.open(file)
    }
  },
};
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
</style>
